

function QuadPess(props) {
  return (

      <div class="col-sm-6 col-6 box-1"  data-aos="fade-up" data-aos-delay="300">
        <div class="row box">
            <div class="col-md-4">
                
                <img src={props.img} alt="pesquisador" width="120" height="130" 
                
                style={{
                  width: 120,
                  height: 130,
                  //Below lines will help to set the border radius
                  borderBottomLeftRadius: 50,
                  borderBottomRightRadius: 50,
                  borderTopRightRadius: 50,
                  borderTopLeftRadius: 50,
                  overflow: 'hidden',
                }}
                /> 
            </div>
            <div class="col-md-8">
                <h3><a href={props.link} target={"_blank"}>{props.nome}</a></h3>
                <h5>{props.funcao}</h5>
                <p><a href={props.link} target={"_blank"} rel="noopener noreferrer">Currículo Lattes</a></p>
                <p>{props.text1}</p>
                <p>{props.text2}</p>
            </div>
        </div>
      </div>
    
  );
}

export default QuadPess;
